import * as t from "io-ts";

export const UserEvent = t.intersection([
  t.type({
    id: t.string,
    verified: t.boolean,
    name: t.string,
    email: t.string,
    provider: t.union([
      t.literal("system"),
      t.literal("firebase"),
      t.literal("google"),
      t.literal("facebook"),
    ]),
  }),
  t.partial({
    cid: t.string,
    mobile: t.string,
    role: t.string,
  }),
]);

export interface UserEvent {
  id: string;
  cid?: string;
  verified: boolean;
  name: string;
  email: string;
  mobile?: string;
  role?: string;
  provider: "system" | "firebase" | "google" | "facebook";
}
